/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Blank_Frames_Failed_ToastInputs */

const en_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames failed`)
};

const fr_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de l'insertion de frames vides`)
};

const de_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einfügen leerer Frames ist fehlgeschlagen.`)
};

const it_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di frame vuoti non riuscito`)
};

const ru_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось вставить пустые рамки.`)
};

const es_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al insertar marcos en blanco`)
};

const zh_cn2_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白帧失败`)
};

const ja_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白フレームの挿入に失敗しました`)
};

const hi_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डालने में विफलता`)
};

const pt_pt2_iframe_remote_blank_frames_failed_toast = /** @type {(inputs: Iframe_Remote_Blank_Frames_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A inserção de quadros em branco falhou.`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames failed" |
*
* @param {Iframe_Remote_Blank_Frames_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_blank_frames_failed_toast = /** @type {((inputs?: Iframe_Remote_Blank_Frames_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Blank_Frames_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "de") return de_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "it") return it_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "ru") return ru_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "es") return es_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "ja") return ja_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "hi") return hi_iframe_remote_blank_frames_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_blank_frames_failed_toast(inputs)
	return en_iframe_remote_blank_frames_failed_toast(inputs)
});